import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageProcessingService {

  constructor() { }

  createCircularImage(url: string, size: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      // S3 only adds CORS headers when the request has an Origin and doesn't vary on it, so a thumbnail already
      // cached from a plain <img> (photo chip, reports) comes back without them and the canvas load fails.
      // A separate query key keeps this CORS request out of that cache entry (not `cors`: S3 reads that as the
      // bucket-CORS sub-resource and returns 403); presigned URLs are left alone.
      image.src = /X-Amz-Signature=/i.test(url) ? url : `${url}${url.includes('?') ? '&' : '?'}map=1`;

      image.onload = () => {
        // Account for device pixel ratio for sharp rendering on retina displays
        const dpr = window.devicePixelRatio || 1;
        const scaledSize = size * dpr;

        const canvas = document.createElement('canvas');
        canvas.width = scaledSize;
        canvas.height = scaledSize;

        const ctx = canvas.getContext('2d');
        if (ctx) {
          // Scale context to match device pixel ratio
          ctx.scale(dpr, dpr);

          // Enable high-quality image rendering
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';

          // Clip to a circular path for transparency
          ctx.beginPath();
          ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2, true);
          ctx.closePath();
          ctx.clip();

          // Draw the image, centered and resized to fit the circle
          ctx.drawImage(image, 0, 0, size, size);

          // Convert canvas to a Base64 URL
          const base64Url = canvas.toDataURL('image/png');

          // Clean up by setting references to null
          canvas.remove();  // Explicitly remove canvas from memory
          image.src = '';   // Clean up the image source
          resolve(base64Url); // Return the Base64 URL with transparent background

        } else {
          reject('Could not get canvas context');
        }
      };

      image.onerror = () => {
        reject('Image loading failed');
      };
    });
  }
}
